import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			//{ value: '1', label: 'Simples' },
			{ value: '3', label: 'Normal' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

